export const satelliteEn = {
  satellite: {
    title: "Satellite Imagery",
    subtitle: "View and analyze satellite images of your parcels",
    selectParcel: "Select Parcel",
    selectDate: "Select Date",
    indexType: "Index Type",
    ndvi: "NDVI - Vegetation Health",
    ndwi: "NDWI - Water Content",
    evi: "EVI - Enhanced Vegetation",
    savi: "SAVI - Soil Adjusted",
    ndre: "NDRE - Chlorophyll",
    downloadImage: "Download Image",
    compareImages: "Compare Images",
    cloudCoverage: "Cloud Coverage",
    resolution: "Resolution",
    acquisitionDate: "Acquisition Date",
    noImagesAvailable: "No images available for this date",
    loading: "Loading satellite imagery..."
  },
  satellitePage: {
    title: "Satellite Analysis",
    subtitle: "Recent imagery from Copernicus Sentinel-2 (5-day revisit cycle) via Sentinel Hub API",
    openeoQuota: "OpenEO Quota",
    remaining: "remaining",
    selectParcelAnalysis: "Select Parcel & Analysis Type",
    selectParcel: "Select Parcel",
    analysisType: "Analysis Type (Filter)",
    changeFilterInfo: "Change the analysis type filter to view different satellite analyses applied to the images",
    noParcelAvailable: "No Parcels Available",
    noParcelDesc: "Add parcels to your account to start viewing real-time satellite imagery",
    goToParcels: "Go to Parcels Manager",
    sarTitle: "SAR Radar Analysis (Sentinel-1)",
    cloudFree: "Cloud-Free",
    sarDesc: "Synthetic Aperture Radar works through clouds and at night - ideal when optical imagery is unavailable",
    penetratesClouds: "Penetrates clouds and works in all weather conditions",
    detectsStructure: "Detects crop structure, soil moisture, and field boundaries",
    loadSar: "Load SAR Analysis",
    loadingSar: "Loading SAR...",
    sarView: "SAR Radar View",
    sarDataSource: "Data source: Copernicus Sentinel-1 GRD (VV/VH polarization)",
    highResTitle: "Need Higher Resolution Imagery?",
    upgrade: "UPGRADE",
    cropValidation: "Crop Validation",
    pkFertilization: "P&K Fertilization",
    cropValidationDesc: "AI-powered crop validation using WorldCereal satellite data",
    pkFertilizationDesc: "Smart phosphorus and potassium optimization for your crops",
    copernicusActive: "Copernicus Active",
    updateData: "Update Data",
    noParcelsAvailable: "No Parcels Available",
    addParcelsToAccess: "Add parcels to access advanced analysis capabilities.",
    selectParcelPlaceholder: "Choose a parcel to view satellite imagery",
    satelliteDataSource: "Satellite Data Source",
    esaCopernicus: "ESA Copernicus Sentinel-2",
    resolution: "Resolution: 10m per pixel",
    updateFrequency: "Update frequency: Every 5 days",
    coverageGlobal: "Coverage: Global",
    dataProcessing: "Data Processing",
    cloudMaskingApplied: "Cloud masking applied",
    atmosphericCorrection: "Atmospheric correction",
    realTimeAnalysis: "Real-time analysis",
    applicationsSat: "Applications",
    cropHealthMonitoring: "Crop health monitoring",
    insuranceClaimValidation: "Insurance claim validation",
    yieldPredictionSat: "Yield prediction",
    lastSatellitePass: "Last satellite pass",
    nextUpdateLabel: "Next update",
    loadingSatelliteData: "Loading satellite data...",
    successUpdate: "Satellite data updated successfully",
    errorRefresh: "Failed to refresh satellite data",
    errorLoad: "Failed to load satellite data",
    saveIndexPanelTitle: "Historical {{index}} record",
    saveIndexPanelWaiting: "Load a real {{index}} image before saving.",
    saveIndexPanelReady: "Real image loaded. Capture date: {{date}}.",
    saveIndexButton: "Save {{index}} record",
    saveIndexSaving: "Saving…",
    saveIndexSuccessTitle: "Index record saved",
    saveIndexSuccessDesc: "{{index}} record saved for this parcel.",
    saveIndexAlreadyTitle: "Already saved",
    saveIndexAlreadyDesc: "{{index}} record already saved for this date.",
    saveIndexLoadImageTitle: "Load image first",
    saveIndexLoadImageDesc: "Load a real {{index}} image before saving.",
    saveIndexErrorTitle: "Could not save index record",
    saveIndexErrorDesc: "The {{index}} image loaded, but the historical record could not be saved.",
    premiumImagery: {
      title: "Need higher-resolution imagery?",
      badge: "PREMIUM SERVICE",
      heading: "Premium satellite imagery on request",
      body: "Sentinel Crop uses Sentinel-2 as the standard layer for recurring field monitoring. For projects that require more detail, you can request commercial high-resolution imagery on demand, from 1.5 m to 30 cm, depending on availability, location, resolution and acquisition type.",
      bullet1: "Detailed sub-parcel analysis",
      bullet2: "Better visual identification of crop variability",
      bullet3: "Premium evidence for reports, audits and insurance cases",
      bullet4: "Useful for pilots, cooperatives and enterprise clients",
      bullet5: "Available on request with global coverage",
      pricing: "From €199 per request",
      pricingNote: "Starting price is indicative for basic requests. Final pricing depends on resolution, minimum area, archive availability, new acquisition and licensing conditions.",
      cta: "Request premium quote",
      footer: "Optional service quoted case by case. Does not include automatic image download from the platform.",
      formTitle: "Request premium imagery quote",
      formSubtitle: "Tell us about your project. Our team will reply with a tailored quote.",
      fieldName: "Name",
      fieldEmail: "Email",
      fieldCompany: "Company",
      fieldRegion: "Country / region",
      fieldArea: "Approximate area (ha)",
      fieldResolution: "Desired resolution",
      fieldNeed: "Need type",
      fieldAcquisition: "Acquisition type",
      fieldMessage: "Message",
      resolution_15m: "1.5 m",
      resolution_50cm: "50 cm",
      resolution_30cm: "30 cm",
      resolution_unsure: "Not sure",
      need_report: "Technical report",
      need_internal: "Image for internal use",
      need_audit: "Audit or insurance",
      need_enterprise: "Enterprise project",
      need_unsure: "Not sure",
      acq_archive: "Archive",
      acq_new: "New acquisition",
      acq_unsure: "Not sure",
      submit: "Send request",
      submitting: "Sending…",
      successTitle: "Request sent",
      successDesc: "We received your request. Our team will reply with a tailored quote.",
      errorTitle: "Could not send request",
      errorDesc: "Please try again, or email jose@sentinelcrop.com directly."
    }
  },
  splitViewPage: {
    title: "Split View Comparison",
    subtitle: "Compare satellite imagery from different dates side by side",
    selectParcel: "Select a parcel",
    selectParcelDesc: "Choose a parcel from the dropdown above to compare satellite imagery.",
    loading: "Loading Split View..."
  },
  splitView: {
    previous: "Previous",
    next: "Next",
    recentMonth: "Recent Month",
    olderMonth: "Older Month",
    capturing: "Capturing...",
    capture12Months: "Capture 12 months",
    showDifferences: "Highlight changes",
    hideDifferences: "Hide changes",
    generatingDifferences: "Calculating visual differences...",
    differencesHint: "Highlighted areas show the most relevant visual changes between both months.",
    differencesUnavailable: "Clear visual differences could not be isolated for this image pair.",
    differencesBadge: "Changes",
    loading: "Loading...",
    noSatelliteData: "No satellite data for this month",
    previewNoData: "Preview — No real data",
    footerText: "Copernicus Sentinel-2 · Month-by-month navigation to view temporal evolution of the parcel",
    recent: "Recent",
    older: "Older"
  },
  temporalComparison: {
    title: "Temporal Comparison",
    currentMonth: "Current Month",
    previousMonth: "Previous Month",
    trend: "Trend",
    noData: "No data",
    improvement: "Improvement",
    decline: "Decline",
    stable: "Stable",
    analysis: "Analysis",
    significantImprovement: "✅ Significant improvement in vegetation health",
    declineDetected: "⚠️ Decline detected - review conditions",
    stableConditions: "➡️ Stable conditions"
  }
};
